// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__5zsoq","fileBtn":"File_fileBtn__1erZd","closeBtn":"File_closeBtn__2tAKm","fileSelected":"File_fileSelected__227Wy","disabled":"File_disabled__1Iuh1"};